import { render, staticRenderFns } from "./withdraw_ios.vue?vue&type=template&id=93d5058c&scoped=true&"
import script from "./withdraw_ios.vue?vue&type=script&lang=js&"
export * from "./withdraw_ios.vue?vue&type=script&lang=js&"
import style0 from "./withdraw_ios.vue?vue&type=style&index=0&id=93d5058c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d5058c",
  null
  
)

export default component.exports